module.exports = __webpack_public_path__ + "img/image10.fa5a8d97.png";